import type { ReactNode } from "react";
import React from "react";
import { cn } from "@/lib/utils";
import { Card } from "./card";
import { TrendingDown, TrendingUp } from "lucide-react";

export type StatisticCardProps = React.PropsWithChildren & {
    className?: string;
    header: ReactNode;
    description: ReactNode;
    headerIcon: React.ElementType<{ className?: string }>;
    trend?: "up" | "down" | number;
    lessIsBetter?: boolean;
};

export const StatisticCard = ({
    header,
    description,
    children,
    className,
    headerIcon: HeaderIcon,
    trend,
    lessIsBetter,
}: StatisticCardProps): JSX.Element => {
    return (
        <Card className={cn("flex flex-col gap-2 p-6 shadow-xs", className)}>
            <div className="text-card-foreground flex justify-between gap-1 text-sm leading-normal font-medium">
                <div>{header}</div>
                <HeaderIcon className="h-4 w-4" />
            </div>
            <div>
                <div className="text-card-foreground text-2xl leading-normal font-bold">
                    {children}
                </div>
                <div className="text-muted-foreground flex gap-1 text-xs leading-normal">
                    {(trend == "up" || (typeof trend === "number" && trend > 0)) && (
                        <TrendingUp
                            size={16}
                            className={lessIsBetter ? "text-red-500" : "text-emerald-500"}
                        />
                    )}
                    {(trend == "down" || (typeof trend === "number" && trend < 0)) && (
                        <TrendingDown
                            size={16}
                            className={lessIsBetter ? "text-emerald-500" : "text-red-500"}
                        />
                    )}
                    <div>{description}</div>
                </div>
            </div>
        </Card>
    );
};
